import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
import { itemRouteBuilder, NamedRts } from "@/router";
import { User } from "@/store/modules/users";
import { genericSort, sortIcon } from "@/components/helpers";

export default defineComponent({
  name: "users",
  components: {
    LoadingAnimation,
  },

  setup(_props, ctx) {
    let $store = ctx.root.$store;

    let dataLoaded = ref(false);
    let loadingMessage = ref("Loading Users...");

    const apiUsers = computed(() => {
      return $store.getters.usersForTable as User[];
    });

    const localUsers = ref<User[]>([]);

    const editRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.userEditForm, id);
    };

    const users = computed(() => {
      let tmpResults = [...localUsers.value];
      // filter the results here, if needed,
      return tmpResults;
    });

    // info for sort
    // let filter = ref("");

    let sortKey = ref<"name" | "email">("name");
    let sortAsc = ref(true);

    const localSortIcon = (lSortKey: "name" | "email") => {
      return sortIcon(sortAsc, sortKey, lSortKey);
    };

    const updateSort = (lSortKey: "name" | "email") => {
      localUsers.value = genericSort(
        [...localUsers.value],
        sortAsc,
        sortKey,
        lSortKey,
      );
    };

    onMounted(() => {
      const jsConn = new JSConn();
      $store.dispatch("needUsers", jsConn).then(() => {
        localUsers.value = [...apiUsers.value];
        // flip the sort, otherwise on load it would be off
        sortAsc.value = !sortAsc.value;
        updateSort(sortKey.value);
        dataLoaded.value = true;
      });
    });

    return {
      dataLoaded,
      loadingMessage,

      users,
      editRouteBuilder,

      updateSort,
      localSortIcon,
    };
  },
});
